<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="dedication" id="dedication_1">
<p class="ded2"><em>For my parents, who nurtured my creativity, taught me the joy of hard work, and showed me every day of my childhood what true love is really all about.</em></p>
<p class="ded"><em>Miss you, Mom.</em></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NoControl_dedi_1.vue?9bc33c00